// extracted by mini-css-extract-plugin
module.exports = {"root":"TakeoverPanel__root--hSS-O","container":"TakeoverPanel__container--1sjeO"};